import { createContext, useContext } from 'react';

export type OnboardingHighlightName =
  | 'RivalsDraftCard'
  | 'RivalsDraftCost'
  | 'RivalsDraftForm'
  | 'RivalsDraftBudget'
  | 'RivalsTactics'
  | 'ArenaPlayButton'
  | 'ClaimFirstBoxMissionDesktop'
  | 'ClaimFirstBoxMissionMobile'
  | 'RankDiamond'
  | 'DivDiamond'
  | 'RepDiamond';

export type OnboardingHighlightConfig = {
  circle?: boolean;
  padding?: number;
  borderRadius?: number;
  border?: boolean;
  onClick?: () => void;
};
export type MeasureHighlightCallback = () => DOMRect | null;

export type CurrentHighlight = {
  name: OnboardingHighlightName;
  measureCallback: MeasureHighlightCallback;
  config?: OnboardingHighlightConfig;
};
export type OnboardingHighlightContext = {
  registerHighlight: ({
    name,
    measureCallback,
    config,
  }: {
    name: OnboardingHighlightName;
    measureCallback: MeasureHighlightCallback;
    config?: OnboardingHighlightConfig;
  }) => void;
  highlights: CurrentHighlight[];
};

export const onboardigHighlightContext =
  createContext<OnboardingHighlightContext | null>(null);

export const useOnboardingHighLightContext = () =>
  useContext(onboardigHighlightContext)!;

export default onboardigHighlightContext;
